module.exports = __webpack_public_path__ + "static/media/location.b7613b12.svg";